import React, {memo} from 'react';
import {Paper, Portal, DialogProps} from '@mui/material';
import {Theme} from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {DialogTitle, DialogContent} from 'components/Dialog';
import Draggable from 'react-draggable';

type RootProps = {
   widthBP: Exclude<DialogProps['maxWidth'], false | undefined>;
};
const useStyles = makeStyles((theme: Theme) => ({
   root: ({widthBP}: RootProps) => ({
      position: 'fixed',
      left: '50%',
      top: '10%',
      marginLeft: theme.breakpoints.values[widthBP] / -2,
      width: theme.breakpoints.values[widthBP],
      zIndex: theme.zIndex.modal,
   }),
   title: {
      cursor: 'move',
   },
}));

type Props = {
   header?: string;
   children?: any;
   width?: RootProps['widthBP'];
   onClose?: () => void;
   onLaunch?: () => void;
};
const DraggableModal = memo(({header, onClose, onLaunch, children, width = 'md'}: Props) => {
   const classes = useStyles({widthBP: width});
   return (
      <Portal>
         <Draggable handle="#draggable-dialog-title">
            <Paper className={classes.root} elevation={24}>
               <DialogTitle
                  id="draggable-dialog-title"
                  className={classes.title}
                  onClose={onClose}
                  onLaunch={onLaunch}
               >
                  {header}
               </DialogTitle>
               <DialogContent dividers>{children}</DialogContent>
            </Paper>
         </Draggable>
      </Portal>
   );
});

export default DraggableModal;
